import { get, post, patch, deleteReq } from "../helpers/fetcher";

export const postBilling = async (user, body) => {
  const endpoint = `/billing`;
  const header = { "Content-Type": "application/json" };

  return post(endpoint, header, body);
};
